var React = require('react');

function Youtube (props) {
    return React.createElement("g",props,[React.createElement("rect",{"style":{"fill":"#CC191E"},"width":"23","height":"23","key":0}),React.createElement("path",{"className":"iwh","d":"M19.8,8.4c0,0-0.2-1.1-0.6-1.6c-0.6-0.6-1.3-0.6-1.6-0.7C15.4,6,12,6,12,6h0c0,0-3.4,0-5.6,0.2     c-0.3,0-1,0-1.6,0.7C4.3,7.3,4.2,8.4,4.2,8.4S4,9.6,4,10.9v1.2c0,1.3,0.2,2.5,0.2,2.5s0.2,1.1,0.6,1.6c0.6,0.6,1.4,0.6,1.8,0.7     C7.8,17,12,17,12,17s3.4,0,5.6-0.2c0.3,0,1,0,1.6-0.7c0.5-0.5,0.6-1.6,0.6-1.6s0.2-1.3,0.2-2.5v-1.2C20,9.6,19.8,8.4,19.8,8.4z      M10.1,13.7l0-4.8l4.7,2.4L10.1,13.7z","key":1})]);
}

Youtube.defaultProps = {"id":"youtubeicon","viewBox":"0 0 23 23"};

module.exports = Youtube;

Youtube.default = Youtube;
